import React, { lazy, Suspense, useState, FC, useEffect } from "react";

import { useLocation } from "react-router-dom";
import TabPetsProfile from "./TabPetsProfile";
import Header from "../../../components/molecules/Header/Header";
import Container from "../../../components/layout/Container/Container";
import Banner from "../../../components/layout/Sections/Banner";
import TabButton from "../../../components/layout/Sections/TabButton";
import TabContent from "../../../components/layout/Sections/TabContent";
import Footer from "../../../components/molecules/Footer/Footer";
import TabPetsOwnershipChange from "./TabPetsOwnershipChange";
import PetsRegistrationEditForm from "./PetsRegistrationEditForm";
import PetsTransferOwnerEditForm from "./PetsTransferOwnerEditForm";
import PetsDashboard from "../../DashBoard/Microchip/Pets/PetsDashboard";
import { useNavigate } from "react-router-dom";
import TabPetsReport from "./TabPetsReport";
import PetsBulkRegistration from "./PetsBulkRegistration";
import TabPetsTransferProfile from "./TabPetsTransferProfile";

interface TabPages {
  [key: string]: FC<any>;
}

const ApplicationForPets = () => {
  let navigate = useNavigate();
  const name = "E-services";
  const name2 = "Dashboard";
  const name3 = "Register";
  const name4 = "Transfer";
  //const name5 = "Report";
  const name6 = "Bulk Registration";
  const buttonName = "Register a Pet";
  const buttonName1 = "Register Pets (Bulk)";
  const buttonName2 = "My Pets";
  const buttonName3 = "Transfer Pet Ownership";
  const buttonName4 = "Transfer a Pet";
  //const buttonName5 = "Lost and Found Pet Report";
  //const buttonName6 = "Lost and Found Pet Reports List";
  const buttonName7 = ""; //pets Registration edit
  const buttonName8 = ""; //Pets Transfer edit
  const buttonName9 = "Bulk Registration"; //Pets Transfer edit
  const buttonName10 = "My Pet Registrations";

  let petsRegistrationId, buttonId, tabId, bannerId, bannerType: any;
  const location = useLocation();
  const [transfer, setIsTransfer] = useState(false);
  const [transferApplicationId, setTransferApplicationId] = useState("");

  useEffect(() => {
    if (location.state) {
      const {
        petsRegistrationId,
        petsTransferApplicationId,
        buttonId,
        tabId,
        bannerId,
        bannerType,
        isTransfer,
      } = location.state;

      if (isTransfer) setIsTransfer(true);
      if (petsTransferApplicationId)
        setTransferApplicationId(petsTransferApplicationId);
      else setTransferApplicationId("");

      if (
        (petsRegistrationId || petsTransferApplicationId) &&
        buttonId &&
        tabId &&
        bannerId
      ) {
        switch (bannerId) {
          case 2: // For Pet Registration Edit
            handleButtonClick("v-pills-profile-tab", "v-pills-profile", 2);
            break;
          case 4: // For Owner Transfer
            handleButtonClick("v-pills-homeT-tab", "v-pills-homeT", 4);
            break;
          case 5: // For Lost and Found report
            handleButtonClick("v-pills-report-tab", "v-pills-report", 5);
            break;
          case 7: // For Pet Registration Edit
            handleButtonClick(
              "v-pills-petsregedit-tab",
              "v-pills-petsregedit",
              7
            );
            break;
          case 8: // For Pet Transfer Edit
            handleButtonClick(
              "v-pills-petstransferedit-tab",
              "v-pills-petstransferedit",
              8
            );
            break;
          default:
            // You can add more cases or a default action here
            break;
        }
      } else if (bannerId) {
        if (bannerId === 5)
          handleButtonClick("v-pills-report-tab", "v-pills-report", 5);
        if (bannerId === 10)
          handleButtonClick(
            "v-pills-petstransfer-tab",
            "v-pills-petstransfer",
            10
          );
      }
    }
  }, [location.state]);

  const [transferType, setTransferType] = useState<string>("Pets");
  const [activeButton, setActiveButton] = useState<string>(
    "v-pills-services-tab"
  );
  const [activeTab, setActiveTab] = useState<string>("v-pills-services");
  const [bannerName, setbannerName] = useState<string>("My Pets");

  const switchToHomeTTab = () => {
    // Implement the logic to switch to the "v-pills-homeT" tab
    setActiveButton("v-pills-homeT-tab");
    setActiveTab("v-pills-homeT");
    // ... (other logic)
  };

  const handleButtonClick = (
    buttonId: string,
    tabId: string,
    bannerId: any
  ) => {
    setActiveButton(buttonId);
    setActiveTab(tabId);
    if (bannerId == 1) {
      setbannerName("My Pets");
      setTransferType("Pets");
    } else if (bannerId == 2) {
      setbannerName("Pet Transfer Applications");
      setTransferType("PetsPendingRegistration");
    } else if (bannerId == 3) {
      setbannerName("Application for pet other than dogs");
    } else if (bannerId == 4) {
      setbannerName("Transfer Pet Ownership");
    } else if (bannerId == 5) {
      setbannerName("Lost and Found Pet Report");
    } else if (bannerId == 6) {
      setbannerName("Lost and Found Pet Reports List");
      setTransferType("LostAndFoundPets");
    } else if (bannerId == 7) {
      setbannerName("My Pet Information");
      setTransferType("PetRegistrationEditForm");
    } else if (bannerId == 8) {
      setbannerName("Pet Transfer Edit Form");
      setTransferType("PetsTransferOwnerEditForm");
    } else if (bannerId == 9) {
      setbannerName("Bulk Registration");
    } else if (bannerId == 10) {
      setbannerName("Transfer Pet Ownership");
    } else if (bannerId == 11) {
      setbannerName("My Pet Registrations");
      setTransferType("PetsRegistration");
    }
  };

  // const handleButtonClick3 = (buttonId: string, tabId: string) => {
  //   setActiveButton(buttonId);
  //   setActiveTab(tabId);

  //   setbannerName("Dashboard for pets other than dogs");
  //   // let path = `/app-pet-dashboard`;
  //   // navigate(path, { state: { transferType } });
  // };

  const tabPages: TabPages = {
    // "v-pills-home": TabPetsProfile,
    "v-pills-home": (props) => (
      <TabPetsProfile
        onSuccessfulSubmit={() => {
          window.location.reload();
          handleButtonClick("v-pills-services-tab", "v-pills-services", 1);
        }}
        {...props}
      />
    ),
    "v-pills-homeT": (props) => (
      <TabPetsOwnershipChange
        onSuccessfulSubmit={() => {
          handleButtonClick("v-pills-profile-tab", "v-pills-profile", 2);
        }}
        isTransfer={{ transfer }}
        {...props}
      />
    ),
    "v-pills-services": (props) => (
      <PetsDashboard RegistrationType="{}" transferType="Pets" {...props} />
    ), //PetsDashboard,
    "v-pills-petregistrations": (props) => (
      <PetsDashboard
        RegistrationType="{}"
        transferType="PetsRegistration"
        {...props}
      />
    ), //PetsDashboard,
    "v-pills-profile": PetsDashboard,
    "v-pills-report": (props) => (
      <TabPetsReport
        onSuccessfulSubmit={() => {
          handleButtonClick(
            "v-pills-lostandfoundlist-tab",
            "v-pills-lostandfoundlist",
            6
          );
        }}
        {...props}
      />
    ),
    "v-pills-lostandfoundlist": PetsDashboard,
    "v-pills-bulkregistration": PetsBulkRegistration,
    "v-pills-petsregedit": (props) => (
      <PetsRegistrationEditForm
        onSuccessfulSubmit={() => {
          handleButtonClick("v-pills-services-tab", "v-pills-services", 1);
        }}
        petsTransferApplicationId={{ transferApplicationId }}
        {...props}
      />
    ),
    "v-pills-petstransferedit": (props) => (
      <PetsTransferOwnerEditForm
        onSuccessfulSubmit={() => {
          handleButtonClick("v-pills-profile-tab", "v-pills-profile", 2);
        }}
        isTransfer={{ transfer }}
        {...props}
      />
    ),
    "v-pills-petstransfer": (props) => (
      <TabPetsTransferProfile
        onSuccessfulSubmit={() => {
          handleButtonClick("v-pills-profile-tab", "v-pills-profile", 2);
        }}
        {...props}
      />
    ),
    // ... add other tab pages here
  };

  // const handleProceedClick = () => {
  //   handleButtonClick("v-pills-profile-tab", "v-pills-profile");
  // };

  return (
    <>
      <Header />
      <Container>
        <Banner name={bannerName} uiClass="banner-bg" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-3">
                <div className="filter-cnt">
                  <h3>{name}</h3>
                  <span>{name2}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-services-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-services-tab",
                          "v-pills-services",
                          1
                        )
                      }
                    >
                      {buttonName2}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-petregistrations-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-petregistrations-tab",
                          "v-pills-petregistrations",
                          11
                        )
                      }
                    >
                      {buttonName10}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-profile-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-profile-tab",
                          "v-pills-profile",
                          2
                        )
                      }
                    >
                      {buttonName3}
                    </TabButton>
                    {/*<TabButton
                      buttonId="v-pills-lostandfoundlist-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-lostandfoundlist-tab",
                          "v-pills-lostandfoundlist",
                          6
                        )
                      }
                    >
                      {buttonName6}
                    </TabButton>*/}
                  </div>
                  <span> {name3}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-home-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-home-tab", "v-pills-home", 3)
                      }
                    >
                      {buttonName}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-bulkregistration-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-bulkregistration-tab",
                          "v-pills-bulkregistration",
                          9
                        )
                      }
                    >
                      {buttonName1}
                    </TabButton>
                  </div>
                  <span> {name4}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-petstransfer-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-petstransfer-tab",
                          "v-pills-petstransfer",
                          10
                        )
                      }
                    >
                      {buttonName4}
                    </TabButton>
                  </div>
                  {/* <span> {name5}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-report-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-report-tab",
                          "v-pills-report",
                          5
                        )
                      }
                    >
                      {buttonName5}
                    </TabButton>
                  </div>
                  <span> {name6}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-petsregedit-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-bulkregistration-tab",
                          "v-pills-bulkregistration",
                          7
                        )
                      }
                    >
                      {buttonName7}
                    </TabButton>
                  </div> */}
                  {/* <span> {name6}</span> */}
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-petstransferedit-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-petstransferedit-tab",
                          "v-pills-petstransferedit",
                          8
                        )
                      }
                    >
                      {buttonName8}
                    </TabButton>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9">
                <div className="tab-content" id="v-pills-tabContent">
                  {Object.keys(tabPages).map((tabId) => (
                    <TabContent key={tabId} tabId={tabId} activeTab={activeTab}>
                      {tabPages[tabId]({
                        RegistrationType: bannerType,
                        transferType,
                      })}
                    </TabContent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default ApplicationForPets;
